import { Fragment } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import ButtonCinestar from '../../../../../../../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../../../../../Typography/Typography'

import './ChooseCinemaDesktop.scss'

const ChooseCinemaDesktop = ({ cinemas, selectedCinema, selectCinemaHandler, confirmHandler, titleId }) => {
    const intl = useIntl()

    return (
        <Container fluid className="choose-cinema-desktop">
            <Typography variant={'sectionHeadline'}>{intl.formatMessage({ id: titleId })}</Typography>
            <div className="choose-cinema-desktop__selection">
                {cinemas?.map((cinema) => (
                    <Fragment key={cinema?.id}>
                        {cinema?.id !== selectedCinema?.id ? (
                            <ButtonCinestar
                                variant={'secondary'}
                                className={'choose-cinema-desktop__selection--cinema'}
                                onClick={() => selectCinemaHandler(cinema)}
                            >
                                {cinema?.name}
                            </ButtonCinestar>
                        ) : (
                            <div className="choose-cinema-desktop__selection--cinema d-flex flex-column justify-content-between bg-white text-center p-2">
                                <Typography variant={'buttonPrimary'} color={'basePrimary'} className={'my-auto'}>
                                    {cinema?.name}
                                </Typography>
                                <ButtonCinestar
                                    variant={'primary-v1'}
                                    size={'sm'}
                                    onClick={() => confirmHandler(cinema)}
                                >
                                    {intl.formatMessage({ id: 'buttons.confirm' })}
                                </ButtonCinestar>
                            </div>
                        )}
                    </Fragment>
                ))}
            </div>
        </Container>
    )
}

export default ChooseCinemaDesktop
